import { toast } from "react-toastify";

const opts = { position: "top-right", autoClose: 3000 };

export const showToast = (type, message) => {
  switch (type) {
    case "success": return toast.success(message, opts);
    case "error": return toast.error(message, opts);
    case "info": return toast.info(message, opts);
    case "warning": return toast.warning(message, opts);
    default: return toast(message, opts);
  }
};

export const showApiError = (error, fallback = "Something went wrong") => {
  // Laravel 422s carry the useful text in `errors` (per-field); the top-level
  // message is just "Validation Error". Surface the first field error so the
  // user sees what actually went wrong, falling back to the generic message.
  const errors = error?.data?.errors;
  let fieldMsg;
  if (errors && typeof errors === "object") {
    const first = Object.values(errors)[0];
    fieldMsg = Array.isArray(first) ? first[0] : first;
  }
  const msg = fieldMsg || error?.message || error?.data?.message || fallback;
  toast.error(msg, opts);
};
